var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-page bold tablec" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-row" },
      [
        _c(
          "Widget",
          {
            staticClass: "shares-widget w-100 bg-transparent",
            attrs: { title: "" }
          },
          [
            _c(
              "b-tabs",
              { staticClass: "mb-lg" },
              [
                _c("b-tab", { attrs: { title: "Behaviour", active: "" } }, [
                  _c("div", { staticClass: "display-flex" }, [
                    _c(
                      "div",
                      { staticClass: "mt-5", staticStyle: { width: "70%" } },
                      [
                        _c("h4", {}, [
                          _c("i", {
                            staticClass: "fa fa-circle",
                            class:
                              "text-" +
                              (_vm.behaviour.public ? "success" : "inverse")
                          }),
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.behaviour.title) +
                              "\n                                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("h6", [_vm._v(_vm._s(_vm.behaviour.description))]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(
                            _vm._s(_vm.formatDate(_vm.behaviour.startDate)) +
                              " - " +
                              _vm._s(_vm.formatDate(_vm.behaviour.endDate))
                          )
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.hasAdminRole()
                  ? _c(
                      "b-tab",
                      { attrs: { title: "Badges" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mb-3 mt-3",
                            attrs: { variant: "success" },
                            on: {
                              click: function($event) {
                                return _vm.goToManageBadges()
                              }
                            }
                          },
                          [_vm._v("Manage badges")]
                        ),
                        _vm._v(" "),
                        _vm.selectedBehaviourBadges.length == 0
                          ? _c("h6", [_vm._v("No badges configured yet!")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "list-group list-group-lg" },
                          _vm._l(_vm.selectedBehaviourBadges, function(badge) {
                            return _c(
                              "div",
                              {
                                key: badge.id,
                                staticClass: "list-group-item",
                                attrs: { href: "#" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "thumb-xl mr",
                                    staticStyle: { width: "100px" }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: badge.downloadUrl,
                                        alt: "..."
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticStyle: { width: "70%" } }, [
                                  _c("h4", {}, [
                                    _c("i", {
                                      staticClass: "fa fa-circle",
                                      class:
                                        "text-" +
                                        (badge.public ? "success" : "inverse")
                                    }),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(badge.title) +
                                        "\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("h6", [_vm._v(_vm._s(badge.description))])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ml-auto" },
                                  [
                                    _c(
                                      "b-popover",
                                      {
                                        staticClass: "popover-danger",
                                        attrs: {
                                          triggers: "click",
                                          target:
                                            "popoverDeleteBadge_" + badge.id,
                                          show: _vm.badgePopover[badge.id],
                                          placement: "top"
                                        },
                                        on: {
                                          "update:show": function($event) {
                                            return _vm.$set(
                                              _vm.badgePopover,
                                              badge.id,
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _c("div", { staticClass: "px-5" }, [
                                            _vm._v(
                                              "Are you sure you want to delete this badge?"
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "px-5 d-flex justify-content-center"
                                          },
                                          [
                                            _c(
                                              "b-button-toolbar",
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "success",
                                                      size: "xs"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteBadgeRequest(
                                                          badge.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    Yes\n                                                "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "danger",
                                                      size: "xs"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.closePopover(
                                                          badge.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    No\n                                                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-tab",
                  { attrs: { title: "Awards" } },
                  [
                    _vm.hasAdminRoleByGlobal(_vm.behaviour.global)
                      ? _c(
                          "b-button",
                          {
                            staticClass: "mb-3 mt-3",
                            attrs: { variant: "success" },
                            on: {
                              click: function($event) {
                                return _vm.goToManageAwards()
                              }
                            }
                          },
                          [_vm._v("Manage awards")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedBehaviourAwards.length == 0
                      ? _c("h6", [_vm._v("No awards configured yet!")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "list-group list-group-lg" },
                      _vm._l(_vm.selectedBehaviourAwards, function(award) {
                        return _c(
                          "div",
                          {
                            key: award.id,
                            staticClass: "list-group-item",
                            attrs: { href: "#" }
                          },
                          [
                            _c(
                              "b-tabs",
                              {
                                staticClass: "mb-lg",
                                attrs: { pills: "", vertical: "" }
                              },
                              [
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: "Award details",
                                      "title-item-class": "mytab",
                                      active: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "thumb-xl mr",
                                        staticStyle: { width: "100px" }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: award.downloadUrl,
                                            alt: "..."
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { width: "70%" } },
                                      [
                                        _c("h4", {}, [
                                          _c("i", {
                                            staticClass: "fa fa-circle",
                                            class:
                                              "text-" +
                                              (award.public
                                                ? "success"
                                                : "inverse")
                                          }),
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(award.title) +
                                              "\n                                            "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("h6", [
                                          _vm._v(_vm._s(award.description))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDate(award.startDate)
                                              ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.formatDate(award.endDate)
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: "Claimed by",
                                      "title-item-class": "mytab"
                                    }
                                  },
                                  [
                                    _vm.awardsClaimedBy[award.id]
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.awardsClaimedBy[award.id],
                                            function(user) {
                                              return _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "display-flex p-2 w-25",
                                                    staticStyle: {
                                                      "justify-content":
                                                        "space-between"
                                                    }
                                                  },
                                                  [
                                                    _c("div", [
                                                      user.avatarUrl
                                                        ? _c("img", {
                                                            staticClass:
                                                              "profileAvatar rounded-circle mr-2",
                                                            staticStyle: {
                                                              "vertical-align":
                                                                "middle",
                                                              width: "50px",
                                                              height: "50px",
                                                              "border-radius":
                                                                "50%"
                                                            },
                                                            attrs: {
                                                              src:
                                                                user.avatarUrl
                                                            }
                                                          })
                                                        : _c("img", {
                                                            staticClass:
                                                              "profileAvatar rounded-circle mr-2",
                                                            staticStyle: {
                                                              "vertical-align":
                                                                "middle",
                                                              width: "50px",
                                                              height: "50px",
                                                              "border-radius":
                                                                "50%"
                                                            },
                                                            attrs: {
                                                              src: require("../../assets/people/default_avatar.png"),
                                                              alt: "..."
                                                            }
                                                          }),
                                                      _vm._v(
                                                        "\n                                                        " +
                                                          _vm._s(
                                                            user.displayName
                                                          ) +
                                                          "\n                                                    "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex-column",
                                                        staticStyle: {
                                                          "justify-content":
                                                            "center",
                                                          display: "flex"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ml-auto"
                                                          },
                                                          [
                                                            user.confirmed
                                                              ? _c("span", {
                                                                  staticClass:
                                                                    "fa fa-check-circle-o icon-button p-1 text-success",
                                                                  attrs: {
                                                                    id:
                                                                      "popoverDeleteVersion_" +
                                                                      user.id
                                                                  }
                                                                })
                                                              : _c("span", {
                                                                  staticClass:
                                                                    "fa fa-check-circle-o icon-button p-1",
                                                                  attrs: {
                                                                    id:
                                                                      "popoverDeleteVersion_" +
                                                                      user.id
                                                                  }
                                                                })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-popover",
                                                          {
                                                            staticClass:
                                                              "popover-danger",
                                                            attrs: {
                                                              triggers: "click",
                                                              target:
                                                                "popoverDeleteVersion_" +
                                                                user.id,
                                                              show:
                                                                _vm.popovers[
                                                                  user.id
                                                                ],
                                                              placement: "top"
                                                            },
                                                            on: {
                                                              "update:show": function(
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.popovers,
                                                                  user.id,
                                                                  $event
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              { slot: "title" },
                                                              [
                                                                !user.confirmed
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "px-5"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Are you sure you want to mark this award as offered?"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "px-5"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Are you sure you want to mark this award as NOT offered?"
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "px-5 d-flex justify-content-center"
                                                              },
                                                              [
                                                                _c(
                                                                  "b-button-toolbar",
                                                                  [
                                                                    _c(
                                                                      "b-button",
                                                                      {
                                                                        attrs: {
                                                                          variant:
                                                                            "success",
                                                                          size:
                                                                            "xs"
                                                                        },
                                                                        on: {
                                                                          click: function() {
                                                                            _vm.markAwardAsOffered(
                                                                              {
                                                                                id:
                                                                                  user.awardHistoryId,
                                                                                awardId:
                                                                                  award.id,
                                                                                confirmed: !user.confirmed,
                                                                                $toasted:
                                                                                  _vm.$toasted
                                                                              }
                                                                            )
                                                                            _vm.closePopover(
                                                                              user.id
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    Yes\n                                                                "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "b-button",
                                                                      {
                                                                        attrs: {
                                                                          variant:
                                                                            "danger",
                                                                          size:
                                                                            "xs"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.closePopover(
                                                                              user.id
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                                    No\n                                                                "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            "\n                                            No users claimed this award yet.\n                                        "
                                          )
                                        ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }